import {
    bindTrustedActivate,
    decodePacket,
    getPreviewMode,
    isTrustedActionEvent,
    openTrustedUrl,
    sendSlotBeacon
} from "../services/helpers/slot-codec";
import { attachCanvasBadge, mountSlotShadow } from "../services/helpers/slot-shadow";

const boundMediaHosts = new WeakSet();

function checkViewsLimit(key) {
    if (getPreviewMode() !== "") {
        return true;
    }

    if (!localStorage.getItem(key)) {
        localStorage.setItem(key, "1");

        return true;
    }

    const value = +localStorage.getItem(key);

    if (value >= 3) {
        return false;
    }

    localStorage.setItem(key, value + 1);

    return true;
}

function pingOnIntersection(element, id, position) {
    if (!element) {
        return;
    }

    const logView = () => {
        sendSlotBeacon({
            op: "v",
            i: Number(id) || 0,
            p: position || "post",
            s: "__infoSlug" in window ? window.__infoSlug : ""
        });
    };
    const callback = (entries, observer) => {
        entries
            .filter((entry) => entry.isIntersecting)
            .forEach(() => {
                logView();
                observer.disconnect();
            });
    };
    const observer = new IntersectionObserver(callback, {
        threshold: 0.5
    });

    observer.observe(element);
}

function bindClick(element, id, url, position, showTime) {
    if (!element || !url) {
        return;
    }

    element.removeAttribute("href");
    bindTrustedActivate(element, (event) => {
        if (!isTrustedActionEvent(event)) {
            event.preventDefault();

            return;
        }
        if (event.target && event.target.closest && event.target.closest("[data-p-badge]")) {
            return;
        }

        const elapsed = Math.max(1, (new Date).getTime() - showTime);
        sendSlotBeacon({
            op: "c",
            i: Number(id) || 0,
            d: elapsed,
            p: position || "post",
            s: "__infoSlug" in window ? window.__infoSlug : ""
        });
        openTrustedUrl(event, url);
    });
}

function init(container) {
    if (!container || boundMediaHosts.has(container)) {
        return false;
    }
    boundMediaHosts.add(container);

    const cfg = container.dataset.pMedia
        ? decodePacket(container.dataset.pMedia)
        : null;

    const id = (cfg && cfg.id) || container.dataset.imageBanner || "default";
    const position = (cfg && cfg.p) || container.dataset.position || "post";
    container.removeAttribute("data-p-media");
    container.removeAttribute("data-image-banner");
    container.removeAttribute("data-position");
    const storageKey = "pl_mb_" + id;

    if (!checkViewsLimit(storageKey)) {
        container.style.display = "none";

        return false;
    }

    container.style.display = "block";
    const shadowHandle = mountSlotShadow(container, { active: true });
    const root = shadowHandle.root;
    const desktop = root.querySelector("[data-p-d], [data-b-desktop]");
    const mobile = root.querySelector("[data-p-m], [data-b-mobile]");

    const desktopId = (cfg && cfg.di) || (desktop && desktop.dataset.bDesktop) || 0;
    const mobileId = (cfg && cfg.mi) || (mobile && mobile.dataset.bMobile) || 0;
    const desktopUrl = (cfg && cfg.du) || (desktop && desktop.getAttribute("href")) || "";
    const mobileUrl = (cfg && cfg.mu) || (mobile && mobile.getAttribute("href")) || "";

    if (desktop) {
        attachCanvasBadge(desktop, {
            overlay: true,
            id: desktopId,
            url: desktopUrl,
            shadowHandle
        });
    }
    if (mobile) {
        attachCanvasBadge(mobile, {
            overlay: true,
            id: mobileId,
            url: mobileUrl,
            shadowHandle
        });
    }

    const showTime = (new Date).getTime();
    pingOnIntersection(desktop, desktopId, position);
    pingOnIntersection(mobile, mobileId, position);
    bindClick(desktop, desktopId, desktopUrl, position, showTime);
    bindClick(mobile, mobileId, mobileUrl, position, showTime);

    return true;
}

export default function useImageBanner() {
    Array.from(document.querySelectorAll("[data-p-media], [data-image-banner]")).some((item) =>
        init(item)
    );
}
